// Catch-up pass for images that broke before the head.jinja error listener
// was registered (edge case: cached 404s resolved synchronously).
var PH = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Crect width='100' height='100' fill='%23f8f9fa'/%3E%3Cg transform='translate(38,38)' fill='none' stroke='%23ccc' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Crect x='0' y='0' width='24' height='24' rx='2'/%3E%3Ccircle cx='8.5' cy='8.5' r='1.5'/%3E%3Cpolyline points='24 18 16 10 2 24'/%3E%3C/g%3E%3C/svg%3E";

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("img").forEach(function (img) {
    if (img.dataset.brokenHandled) return;
    if (img.hasAttribute("data-no-broken")) return;
    if (img.classList.contains("object-contain")) return;
    var src = img.getAttribute("src");
    if (!src || src === "" || src === "#") return;
    if (img.complete && img.naturalWidth === 0) {
      img.dataset.brokenHandled = "1";
      img.src = PH;
    }
  });
});
